import React from "react";
import PropTypes from "prop-types";

const LaunchCardContent = ({ className = "", title = "", text = null }) => {
  return (
    <div className={`card__content ${className}`}>
      {title && <h3 className="card__title">{title}</h3>}
      {text && <p className="card__text">{text}</p>}
    </div>
  );
};

LaunchCardContent.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string
};

export default LaunchCardContent;
